<template>
    <div
        class="is-dropdown"
        v-show="isVisible">
        <div
            class="close d-md-none"
            @click.stop.prevent="isVisible = false"><i class="i-cross"></i></div>
        <ul>
            <slot />
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Dropdown',
        data() {
            return {
                isVisible: false
            }
        }
    }
</script>

<style lang="scss" scoped>

.is-dropdown {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 5rem 0;
    background-color: #fff;

    @include breakpoint(md) {
        position: absolute;
        top: inherit;
        right: 0;
        bottom: 0;
        left: inherit;
        padding: 3rem 0 0 0;
        transform: translateY(100%);
        background-color: transparent;
    }

    .close {
        position: absolute;
        top: 2rem;
        right: 2rem;
        cursor: pointer;

        @include hover('&') {
            i {
                color: var(--primary);
            }
        }

        i {
            @include transition(0.3s color);
        }
    }

    ul {
        display: flex;
        flex-direction: column;
        margin: -0.5rem;
        padding: 1rem 2.5rem;
        background-color: var(--white);

        @include breakpoint(md) {
            padding: 1rem;
            border: 1px solid var(--grey-50);
            border-radius: 4px;
        }
    }

    li {
        padding: 1rem 0;
        border-bottom: 1px solid #dee5ec;
        font-size: 1.25rem;
        cursor: pointer;

        @include breakpoint(md) {
            margin: 0.5rem;
            padding: 0;
            border-bottom: 0;
            font-size: 1rem;
        }

        @include hover('&') {
            span {
                color: var(--primary);
            }
        }

        span {
            color: var(--secondary);
            font-weight: bold;

            @include transition(0.3s color);
        }

        &:last-of-type {
            border-bottom: 0;
        }

        // a {
        //     span {

        //     }
        // }
    }
}
</style>
